<template>

<div class="  shadow-lg  m-3 p-6 bg-gray-50 ">

            <div class="flex items-center justify-between ">

                  <el-tabs
    v-model="activeName"
    type="card"
    @tab-click="handleClick"
  >
    <el-tab-pane label="销售单" name="N01">

   <N01Com></N01Com>

    </el-tab-pane>
    <el-tab-pane label="充值单" name="N02">
   <N02Com></N02Com>
    </el-tab-pane>
    <el-tab-pane label="消费单" name="N03">
         <N03Com></N03Com>
    </el-tab-pane>
    <el-tab-pane label="核销单" name="N04">
       <N04Com></N04Com>
    </el-tab-pane>
    <el-tab-pane label="业务单" name="N05">
       <N05Com></N05Com>
    </el-tab-pane>
       <el-tab-pane label="充次单" name="N06">
       <N06Com></N06Com>
    </el-tab-pane>
  </el-tabs>

            </div>

</div>

</template>
<script>

import { ref } from 'vue'
import N01Com from '../components/record/n01.vue'
import N02Com from '../components/record/n02.vue'
import N03Com from '../components/record/n03.vue'
import N04Com from '../components/record/n04.vue'
import N05Com from '../components/record/n05.vue'
import N06Com from '../components/record/n06.vue'
export default {
  components: { N01Com, N02Com, N03Com, N04Com, N05Com, N06Com },
  setup () {
    const activeName = ref('N01')
    const handleClick = (tab, event) => {

    }

    return {

      activeName, handleClick
    }
  }
}
</script>
<style scoped>

</style>
